import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import EditFormSeparatorField from 'modules/ui/editform/fields/EditFormSeparatorField';
import CaptchaFamily from '../dto/CaptchaFamily';
import status from '../dto/CaptchaTypeStatus';
import CaptchaTypeEditService from '../service/CaptchaTypeEditService';

const blockClassName = 'rounded-8 border px-16 pt-10 pb-4 mb-16';
// const blockTitleClassName = 'py-8';

const config = {
	key: 'captchaTypeEditForm',
	text: 'Captcha Type',
	textKey: 'captchaType',
	service: CaptchaTypeEditService,
	icon: 'person',
	fields: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'poolSize',
			text: 'Pool Size',
			textKey: 'poolSize',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'engineName',
			text: 'Engine name',
			textKey: 'engineName',
			component: EditFormSelectField,
			required: true,
			type: 'enum',
			items: () => CaptchaTypeEditService.getEngineNames()
		},
		{
			key: 'parametersGroup',
			component: EditFormGroupFields,
			className: blockClassName,
			dependsOn: 'engineName',
			visibleIf: watchers => watchers.engineName !== null,
			fields: [
				{
					key: 'sepParameters',
					text: 'Parameters',
					textKey: 'sepParameters',
					component: EditFormSeparatorField,
					// icon: 'place',
					// className: blockTitleClassName,
					isControlledInput: false
				},
				{
					key: 'parameters.width',
					text: 'Width',
					textKey: 'width',
					component: EditFormTextField,
					required: true,
					type: 'number',
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.height',
					text: 'Height',
					textKey: 'height',
					component: EditFormTextField,
					required: true,
					type: 'number',
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.backgroundColor',
					text: 'Background color',
					textKey: 'backgroundColor',
					component: EditFormTextField,
					required: true,
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.frameDelay',
					text: 'Frame delay',
					textKey: 'frameDelay',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'frameDelay'),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.alphabet',
					text: 'Alphabet',
					textKey: 'alphabet',
					component: EditFormTextField,
					required: true,
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha' || watchers.engineName === 'MaryCaptcha'
				},
				{
					key: 'parameters.horizontalPad',
					text: 'Horizontal padding',
					textKey: 'horizontalPad',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'horizontalPad'),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.fontName',
					text: 'Font name',
					textKey: 'fontName',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					items: () => CaptchaTypeEditService.getFontSelection(),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.fontSize',
					text: 'Font size',
					textKey: 'fontSize',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'fontSize'),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.fontColor',
					text: 'Font color',
					textKey: 'fontColor',
					component: EditFormTextField,
					required: true,
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.fontStrokeColor',
					text: 'Font stroke color',
					textKey: 'fontStrokeColor',
					component: EditFormTextField,
					required: true,
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'SearchLightCaptcha' || watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.startEnd',
					text: 'Start end',
					textKey: 'startEnd',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'startEnd'),
					visibleIf: watchers => watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.fadeInSteps',
					text: 'Fade in steps',
					textKey: 'fadeInSteps',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'fadeInSteps'),
					visibleIf: watchers => watchers.engineName === 'FlitterCaptcha'
				},
				{
					key: 'parameters.stopSteps',
					text: 'Stop steps',
					textKey: 'stopSteps',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'stopSteps'),
					visibleIf: watchers => watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha'
				},
				{
					key: 'parameters.waitBetweenCharacters',
					text: 'Wait between characters',
					textKey: 'waitBetweenCharacters',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'waitBetweenCharacters'),
					visibleIf: watchers => watchers.engineName === 'FlitterCaptcha' || watchers.engineName === 'HMoverCaptcha'
				},
				{
					key: 'parameters.rowDelay',
					text: 'Wait between rows',
					textKey: 'rowDelay',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'rowDelay'),
					visibleIf: watchers => watchers.engineName === 'FlitterCaptcha'
				},
				{
					key: 'parameters.fadeInMode',
					text: 'Fade in mode',
					textKey: 'fadeInMode',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getFadeInMode(filterValue),
					visibleIf: watchers => watchers.engineName === 'FlitterCaptcha'
				},
				{
					key: 'parameters.noiseAmount',
					text: 'Noise amount',
					textKey: 'noiseAmount',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'noiseAmount'),
					visibleIf: watchers => watchers.engineName === 'FlitterCaptcha'
				},

				{
					key: 'parameters.lightCount',
					text: 'Light count',
					textKey: 'lightCount',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'lightCount'),
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.lightColor',
					text: 'Light color',
					textKey: 'lightColor',
					component: EditFormTextField,
					required: true,
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.minRadius',
					text: 'Min. radius',
					textKey: 'minRadius',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'minRadius'),
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.maxRadius',
					text: 'Max. radius',
					textKey: 'maxRadius',
					component: EditFormSelectField,
					required: true,
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelection(filterValue, 'maxRadius'),
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.minSpeed',
					text: 'Min. speed',
					textKey: 'minSpeed',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'minSpeed'),
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.maxSpeed',
					text: 'Max. speed',
					textKey: 'maxSpeed',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'maxSpeed'),
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.mainRadius',
					text: 'Main radius',
					textKey: 'mainRadius',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'mainRadius'),
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.mainSpeed',
					text: 'Main speed',
					textKey: 'mainSpeed',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'mainSpeed'),
					visibleIf: watchers => watchers.engineName === 'SearchLightCaptcha'
				},
				{
					key: 'parameters.squareWidth',
					text: 'Mosaic width',
					textKey: 'mainSsquareWidthpeed',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'squareWidth'),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha'
				},
				{
					key: 'parameters.squareHeight',
					text: 'Mosaic height',
					textKey: 'squareHeight',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'squareHeight'),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha'
				},
				{
					key: 'parameters.squareColor',
					text: 'Mosaic color',
					textKey: 'squareColor',
					component: EditFormTextField,
					required: true,
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha'
				},
				{
					key: 'parameters.squareStrokeColor',
					text: 'Mosaic edge color',
					textKey: 'squareStrokeColor',
					component: EditFormTextField,
					required: true,
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha'
				},
				{
					key: 'parameters.fadeShape',
					text: 'Fade shape',
					textKey: 'fadeShape',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getFadeShape(filterValue),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha'
				},
				{
					key: 'parameters.showSteps',
					text: 'Show steps',
					textKey: 'showSteps',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'showSteps'),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha' || watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.fadeNoise',
					text: 'Fade noise',
					textKey: 'fadeNoise',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'fadeNoise'),
					visibleIf: watchers => watchers.engineName === 'SpreadFadeCaptcha'
				},
				{
					key: 'parameters.moveSteps',
					text: 'Move steps',
					textKey: 'moveSteps',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'moveSteps'),
					visibleIf: watchers => watchers.engineName === 'HMoverCaptcha'
				},
				{
					key: 'parameters.addMotionBlur',
					text: 'Add motion blur',
					textKey: 'addMotionBlur',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getMotionBlur(filterValue),
					visibleIf: watchers => watchers.engineName === 'HMoverCaptcha'
				},
				{
					key: 'parameters.riseSteps',
					text: 'Rise steps',
					textKey: 'riseSteps',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getParameterSelectionEnum(filterValue, 'riseSteps'),
					visibleIf: watchers => watchers.engineName === 'PopupCaptcha'
				},
				{
					key: 'parameters.locale',
					text: 'Locale',
					textKey: 'locale',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getLocale(filterValue),
					visibleIf: watchers => watchers.engineName === 'MaryCaptcha'
				},
				{
					key: 'parameters.miniGameCategory',
					text: 'Mini game category',
					textKey: 'miniGameCategory',
					component: EditFormSelectField,
					required: true,
					type: 'enum',
					filterKey: 'engineName',
					items: filterValue => CaptchaTypeEditService.getMiniGameCategory(filterValue),
					visibleIf: watchers => watchers.engineName === 'MiniGame'
				}
			]
		},
		// {
		// 	key: 'engineParams',
		// 	text: 'Engine paraméter',
		// 	textKey: 'engineParams',
		// 	component: EditFormTextField,
		// 	required: true
		// },
		{
			key: 'captchaFamily',
			text: 'Captcha Family',
			textKey: 'captchaFamily',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: Object.keys(CaptchaFamily).map(d => {
				return { value: d, label: CaptchaFamily[d] };
			})
		},
		{
			key: 'status',
			text: 'Status',
			textKey: 'status',
			component: EditFormSelectField,
			type: 'enum',
			readOnly: true,
			items: Object.keys(status).map(d => {
				return { value: d, label: status[d] };
			})
		}
	]
};

function CaptchaTypeEditForm() {
	return <EditFormPage config={config} />;
}

export default CaptchaTypeEditForm;
